module.exports = __webpack_public_path__ + "img/folderTemplate.4e31c2e5.svg";